interface GetTruncatedLabelListParams {
    labels: ReadonlyArray<string>;
    visibleLabelCount?: number;
    emptyLabel?: string;
}

interface TruncatedLabelList {
    label: string;
    tooltipText: string | undefined;
}

/** Formats labels for a compact cell and exposes the full list when it is truncated. */
const getTruncatedLabelList = ({
    labels,
    visibleLabelCount = 2, // Number of market labels shown in the cell before collapsing the rest into "+N"
    emptyLabel = '-',
}: GetTruncatedLabelListParams): TruncatedLabelList => {
    if (labels.length === 0) {
        return { label: emptyLabel, tooltipText: undefined };
    }

    if (labels.length <= visibleLabelCount) {
        return { label: labels.join(', '), tooltipText: undefined };
    }

    const hiddenLabelCount = labels.length - visibleLabelCount;

    return {
        label: `${labels.slice(0, visibleLabelCount).join(', ')}, +${hiddenLabelCount}`,
        tooltipText: labels.join(', '),
    };
};

export { getTruncatedLabelList };
export type { GetTruncatedLabelListParams, TruncatedLabelList };
